import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlueConfigurationService } from '../../../../services/glue-configuration.service';
import { EGlueResource } from '../../../../configurations/common';
import { IAddress, ISystemDetails } from '../../../../models/common.models';
import { ICartCreateWithEquipmentRequest, ICartCreateWithEquipmentResponse } from '../../../../models/cart.models';
import { AppUtils } from '../../../../utils/app.utils';
import { IStore } from '../../../../models/settings.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CartHttpService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);

  /**
   * Always creates new cart with selected equipment. If user has an active cart with the same equipment, it will not be reused.
   * Returns list of all carts of the user.
   * @param {string} equipmentId
   * @param {IAddress} soldToAddress - optional parameter. If provided, it will be set as soldTo address for created cart.
   * @returns {Observable<ICartCreateWithEquipmentResponse>}
   */
  createNewCartWithEquipment(equipmentId: string, soldToAddress?: IAddress): Observable<ICartCreateWithEquipmentResponse> {
    const url: string = `${this.glueConfiguration.getEndpointUrl()}/${EGlueResource.EXTERNAL_CARTS}`;
    const systemDetails: ISystemDetails = {
      siemensEquipmentId: equipmentId,
      functionalLocation: equipmentId,
      serialNumber: '',
      materialNumber: '',
      namePtBr: '',
      nameEnUs: '',
      company: '',
      companyBusinessUnit: '',
      companyBusinessUnitNumber: '',
      isSparePartsAvailable: false,
    };

    const currentStore: IStore = AppUtils.getCurrentStore();
    const requestBody: ICartCreateWithEquipmentRequest = {
      data: {
        type: EGlueResource.EXTERNAL_CARTS,
        attributes: {
          priceMode: currentStore.storeDefaultPriceMode,
          currency: currentStore.storeDefaultCurrency,
          store: currentStore.storeId,
          systemDetails: systemDetails,
          soldToAddress: soldToAddress
        },
      }
    };
    return this.http.post<ICartCreateWithEquipmentResponse>(url, requestBody);
  }
}
